export const compareCaseInsensitive = (a, b) => {
    const collator = new Intl.Collator('it', { sensitivity: 'base' });
    return collator.compare(a, b);
  };

export const compareString = (a, b) => {
    console.log(a + " - " + b);
    const valueA = a?.toLowerCase() || '';
    const valueB = b?.toLowerCase() || '';
    return valueA.localeCompare(valueB);
};

export const capitalize = (str, lower = false) =>
  (lower ? str.toLowerCase() : str).replace(/(?:^|\s|["'([{])+\S/g, match => match.toUpperCase());